module.exports = __webpack_public_path__ + "img/gygx_05.7b2791c3.jpg";